import { ADDRESS_STEP_PROVINCIA } from "Theconstants";
import {
  APELLIDO_DEST,
  fullData,
  NOMBRE_DEST,
} from "pages/checkout/auxiliaries/steps/addressData";

export function validateAddressStep(inputsEnvio: ICompra["datosEnvio"]) {
  const errorObj = {};

  for (const key in inputsEnvio) {
    const typedKey = key as keyof ICompra["datosEnvio"];

    if (
      (typedKey !== "depto" && !inputsEnvio[typedKey]) ||
      inputsEnvio[typedKey] === ADDRESS_STEP_PROVINCIA
    ) {
      errorObj[typedKey] = fullData.find((i) => i.id === typedKey)?.errorMsg;
    }

    if (
      (typedKey === NOMBRE_DEST || typedKey === APELLIDO_DEST) &&
      inputsEnvio[typedKey].length > 25
    ) {
      errorObj[typedKey] = fullData.find((i) => i.id === typedKey)?.errorMsg;
    }
  }
  if (Object.keys(errorObj).length > 0) {
    return [false, errorObj];
  }
  return [true];
}
